var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1419 3.09817C22.3223 3.45174 21.4303 3.70621 20.5116 3.80531C21.4654 3.23862 22.1797 2.34335 22.5205 1.28746C21.6254 1.81993 20.6448 2.1933 19.6223 2.39103C19.1949 1.93413 18.678 1.57015 18.1038 1.32176C17.5296 1.07337 16.9104 0.945895 16.2848 0.947277C13.7535 0.947277 11.7178 2.99906 11.7178 5.51692C11.7178 5.87049 11.7607 6.22406 11.8303 6.56424C8.04012 6.36603 4.65977 4.55531 2.41244 1.78299C2.00296 2.48241 1.78837 3.27877 1.79102 4.08924C1.79102 5.67495 2.59727 7.07317 3.82673 7.89549C3.10219 7.86696 2.39461 7.66781 1.76155 7.31424V7.37049C1.76155 9.59103 3.33119 11.4312 5.42316 11.8544C5.03037 11.9564 4.6263 12.0086 4.22048 12.0098C3.92316 12.0098 3.64191 11.9803 3.35798 11.9401C3.93655 13.7508 5.62137 15.066 7.62762 15.1089C6.05798 16.3383 4.09191 17.0616 1.95709 17.0616C1.57405 17.0616 1.22048 17.0482 0.853516 17.0053C2.87852 18.3044 5.28119 19.0544 7.86869 19.0544C16.2687 19.0544 20.8651 12.0955 20.8651 6.05531C20.8651 5.8571 20.8651 5.65888 20.8517 5.46067C21.741 4.80978 22.5205 4.00353 23.1419 3.09817Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.17713b893aa96a32200a4777951375f5.svg";
export { ForwardRef as ReactComponent };